/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 1373842098@qq.com
 * @Date: 2022-05-05 17:47:30
 * @LastEditors: sj
 * @LastEditTime: 2022-05-17 10:58:01
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { notification } from 'antd'
import { size } from 'lodash'
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { List } from '../../../models/page'
import {
  CountryPageParams,
  DiagnosisPageParams,
} from '../../../services/medical'
import { ThemeContext } from '../../../theme/ThemeContext'
import {
  logoutOrenableCommodity,
  pageCommodity,
  setSelectId,
} from '../../commodity/commoditySlice'
import { Columns } from '../../InventoryPrice/columns'
import { selectInsuranceArray } from '../../tenant/setting/TenentSettingSlice'
import { DiagnosisColumns } from '../Columns'
import {
  CountryPageValue,
  DiagnosisValue,
  getCountryPage,
  getDiagnosisPage,
} from '../medicalSlice'
import { CurrentQuery } from '../westernMedicine/CurrentQuery'
import styles from '../westernMedicine/Materials.module.css'

export const Diagnosis = () => {
  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const insuranceArray = useSelector(selectInsuranceArray)

  const [data, setData] = useState<List<DiagnosisValue>>()

  const [queries, setQueries] = useState<DiagnosisPageParams>({
    size: 10,
    current: 1,
  })

  useEffect(() => {
    if (insuranceArray && insuranceArray.length !== 0) {
      getData()
    }
  }, [queries, insuranceArray])

  const getData = () => {
    dispatch(
      getDiagnosisPage({
        insuranceCode: insuranceArray[0].insuranceCode,
        ...queries,
        servitemName: queries.name,
      })
    )
      .then(unwrapResult)
      .then((res) => {
        setData(res)
      })
  }

  return (
    <div className={styles.content}>
      <CurrentQuery
        code={1305}
        onValueChange={(vs) => {
          setQueries({ ...queries, ...vs })
        }}
      />
      <EditableList
        style={{ color: theme.tc3 }}
        className={styles.table}
        columns={DiagnosisColumns((id) => {
          console.log(id)
        }, queries.size * (queries.current - 1))}
        page={{
          size: queries.size,
          current: queries.current || 1,
          total: data?.total || 0,
          items: data?.records || [],
        }}
        onChangePage={(current, size?: number) => {
          setQueries({
            ...queries,
            current,
            size: size || 10
          })
        }}
      />
    </div>
  )
}
